import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { navLinks } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_5c5d669f-c9f8-4adb-8172-cba45a477e0a/artifacts/fku8950g_N%C3%A9vtelen%20terv%20%281%29.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'backdrop-blur-xl bg-slate-950/70 border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center group" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="Boldigital"
              className="h-10 sm:h-11 lg:h-12 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
              style={{ background: 'transparent' }}
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1 rounded-full border border-white/5 bg-white/[0.03] backdrop-blur-md px-2 py-1.5">
            {navLinks.map((link) => (
              <button
                key={link.id}
                data-testid={`nav-link-${link.id}`}
                onClick={() => scrollToSection(link.id)}
                className="relative text-sm font-medium text-slate-300 hover:text-white px-4 py-2 rounded-full transition-colors duration-300 hover:bg-white/5"
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden lg:block">
            <button
              data-testid="header-cta-button"
              onClick={() => scrollToSection('contact')}
              className="shine group inline-flex items-center gap-2 rounded-full bg-white text-slate-900 px-5 py-2.5 text-sm font-semibold hover:bg-slate-100 transition-all duration-300 shadow-[0_8px_24px_-10px_rgba(255,255,255,0.25)]"
            >
              Ajánlatkérés
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-white rounded-lg hover:bg-white/5"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menü"
          >
            {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden backdrop-blur-xl bg-slate-950/95 border-t border-white/5" data-testid="mobile-menu">
          <nav className="flex flex-col py-4 px-5">
            {navLinks.map((link) => (
              <button
                key={link.id}
                data-testid={`mobile-nav-link-${link.id}`}
                onClick={() => scrollToSection(link.id)}
                className="text-slate-200 hover:text-white py-3 text-left transition-colors duration-300 font-medium border-b border-white/5 last:border-none"
              >
                {link.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-button"
              onClick={() => scrollToSection('contact')}
              className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-white text-slate-900 px-6 py-3 font-semibold"
            >
              Ajánlatkérés
              <ArrowUpRight className="w-4 h-4" />
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
